type GetTagsByGroupsForCreateProps<T> = {
  directory: T[];
  selectedDirectory: string[];
};

export const getTagsByGroupsForCreate = <
  T extends { name: string; id: number },
>({
  directory,
  selectedDirectory,
}: GetTagsByGroupsForCreateProps<T>) => {
  return {
    existing: directory
      .filter(item => selectedDirectory.includes(item.name))
      .map(item => Number(item.id)),
    new: selectedDirectory
      .filter(
        selectedItem => !directory.some(item => item.name === selectedItem)
      )
      .map(selectedItem => selectedItem),
  } as const;
};
